import { TermsCopy } from '@components/ui';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useTranslation } from 'react-i18next';

const legacyTableCellClass = (tableCellClasses as { TableCell?: string })
  .TableCell;

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    background: 'rgb(var(--primary))',
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    border: 'none !important',
    fontSize: 14,
  },
  [`&.${legacyTableCellClass}`]: {
    width: '500px',
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  '&:nth-of-type(odd)': {
    backgroundColor: 'rgb(var(--field)) ',
  },
}));

interface BuyerConditionTableProps {
  wide?: boolean;
}

export function BuyerConditionTable({
  wide = false,
}: BuyerConditionTableProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <>
      <Grid container justifyContent="center" sx={{ mt: 5 }}>
        <Grid item xs={12} md={10} lg={wide ? 12 : 8}>
          <TableContainer
            component={Paper}
            sx={{ borderRadius: '15px !important' }}
          >
            <Table
              sx={{
                minWidth: '100%',
              }}
              aria-label={t('termsSections.tableLabel')}
            >
              <TableHead>
                <TableRow>
                  <StyledTableCell
                    align="left"
                    sx={{ borderTopLeftRadius: '15px', minWidth: '250px' }}
                  >
                    <TermsCopy i18nKey="termsSections.buyerConditionTable.0" />
                  </StyledTableCell>
                  <StyledTableCell
                    align="left"
                    sx={{
                      minWidth: '250px',
                    }}
                  >
                    <TermsCopy i18nKey="termsSections.buyerConditionTable.1" />
                  </StyledTableCell>
                  <StyledTableCell
                    align="left"
                    sx={{
                      minWidth: '250px',
                    }}
                  >
                    <TermsCopy i18nKey="termsSections.buyerConditionTable.2" />
                  </StyledTableCell>
                  <StyledTableCell
                    align="left"
                    sx={{
                      minWidth: '250px',
                    }}
                  >
                    <TermsCopy i18nKey="termsSections.buyerConditionTable.3" />
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <StyledTableRow>
                  <StyledTableCell align="left">
                    <TermsCopy i18nKey="termsSections.buyerConditionTable.4" />
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    <TermsCopy i18nKey="termsSections.buyerConditionTable.5" />
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    <TermsCopy i18nKey="termsSections.buyerConditionTable.6" />
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    <TermsCopy i18nKey="termsSections.buyerConditionTable.7" />
                  </StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell align="left"></StyledTableCell>
                  <StyledTableCell align="left"></StyledTableCell>
                  <StyledTableCell align="left">
                    <TermsCopy i18nKey="termsSections.buyerConditionTable.8" />
                  </StyledTableCell>
                  <StyledTableCell align="left"></StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell align="left"></StyledTableCell>
                  <StyledTableCell align="left"></StyledTableCell>
                  <StyledTableCell align="left"></StyledTableCell>
                  <StyledTableCell align="left">
                    <TermsCopy i18nKey="termsSections.buyerConditionTable.9" />
                  </StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell align="left">
                    <TermsCopy i18nKey="termsSections.buyerConditionTable.10" />
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    <TermsCopy i18nKey="termsSections.buyerConditionTable.11" />
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    <TermsCopy i18nKey="termsSections.buyerConditionTable.12" />
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    <TermsCopy i18nKey="termsSections.buyerConditionTable.13" />
                  </StyledTableCell>
                </StyledTableRow>
                <StyledTableRow>
                  <StyledTableCell align="left">
                    <TermsCopy i18nKey="termsSections.buyerConditionTable.14" />
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    <TermsCopy i18nKey="termsSections.buyerConditionTable.15" />
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    <TermsCopy i18nKey="termsSections.buyerConditionTable.16" />
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    <TermsCopy i18nKey="termsSections.buyerConditionTable.17" />
                  </StyledTableCell>
                </StyledTableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </>
  );
}
